import { isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';

import { useAppSelector } from '../../../../../../hooks/global/typedReduxHooks';
import ChatsCircleIcon from '../../../../../icons/chatsCircleIcon';

import { Button } from '~/components/ui/button';

interface ViewInterviewPlannerProps {
  onClickFooterButton?: () => void;
  showFooter?: boolean;
}

function ViewInterviewPlanner({
  showFooter,
  onClickFooterButton,
}: Readonly<ViewInterviewPlannerProps>) {
  const interviewQuestions = useAppSelector(
    (state) => state.interviewPlanner.interviewQuestions,
  );

  return (
    <div className='mx-4 rounded-md border border-gray-300 gap-4 pb-4 mt-4 max-h-[90%]'>
      <div className='flex flex-row py-2 border-b border-b-gray-300 justify-center'>
        <h5 className='text-sm leading-4 font-medium text-gray-950'>
          <FormattedMessage defaultMessage='Interview  Questions' />
        </h5>
      </div>
      <div className='flex flex-col py-4 flex-grow overflow-y-auto h-[95%]'>
        {isEmpty(interviewQuestions) && (
          <div className='my-4'>
            <div className='flex flex-row justify-center'>
              <ChatsCircleIcon />
            </div>
            <div className='flex flex-row justify-center'>
              <p className='text-sm italic leading-4 text-gray-700'>
                <FormattedMessage defaultMessage='No interview questions yet, add now.' />
              </p>
            </div>
          </div>
        )}
        <div className='h-full overflow-y-auto'>
          {interviewQuestions.map((question, index) => (
            <div className='flex flex-row px-6 gap-4' key={question.id}>
              <div className='flex flex-col basis-4 shrink-0'>{index + 1}.</div>
              <div className='flex flex-col'>{question.question}</div>
            </div>
          ))}
        </div>
      </div>
      {showFooter && (
        <div className='flex flex-row justify-center px-6'>
          {isEmpty(interviewQuestions) && (
            <div
              style={{
                display: 'inline-block',
                background: 'linear-gradient(to right, #2449FC, #00CECF)',
                borderRadius: '8px',
                padding: '2px',
                width: '100%',
              }}
            >
              <Button color='secondary' onClick={onClickFooterButton}>
                <FormattedMessage defaultMessage='Add Questions' />
              </Button>
            </div>
          )}
          {!isEmpty(interviewQuestions) && (
            <div
              style={{
                display: 'inline-block',
                background: 'linear-gradient(to right, #2449FC, #00CECF)',
                borderRadius: '8px',
                padding: '2px',
                width: '100%',
              }}
            >
              <Button
                variant='plain'
                sx={{
                  display: 'block',
                  border: 'none',
                  borderRadius: '6px',
                  background: 'white',
                  width: '100%',
                  color: 'black',
                  '&:hover': {
                    color: 'white !important',
                  },
                }}
                onClick={onClickFooterButton}
              >
                <FormattedMessage defaultMessage='Edit' />
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ViewInterviewPlanner;
